import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */
import FormattedMessage from 'I18n/components/FormattedMessage';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import MarketingContactsSidegradeModal from 'pricing-pages-ui/components/marketing-contacts-sidegrade/MarketingContactsSidegradeModal';
import { productVersionFromProductInventorySelector } from 'pricing-pages-ui/selectors/ProductInventorySelectors';
import { productForSkuIdSelector } from 'pricing-pages-ui/selectors/ProductsSelectors';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { MARKETING } from 'self-service-api/constants/ProductLines'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message

import UIAdminOnlyWrapper from 'ui-addon-upgrades/decorators/UIAdminOnlyWrapper';
import { REQUEST_SKU } from 'ui-addon-upgrades/_core/common/constants/AdminModalTypes';
import { TEAM } from 'ui-addon-upgrades/_core/common/constants/AdminTypes';
import UIButton from 'UIComponents/button/UIButton';

const MarketingContactsSidegradeButton = ({
  use,
  className,
  skuId,
  history,
  trackingSource,
  upgradeData,
  style,
  queryParamTerm
}) => {
  const {
    apiName
  } = useSelector(state => productForSkuIdSelector(state, {
    skuId
  }));
  const [modalVisible, setModalVisible] = useState(false);
  const ownedSkuId = useSelector(state => {
    return (productVersionFromProductInventorySelector(state, {
      productAttributeFilters: {
        productLine: MARKETING
      }
    }) || {}).skuId;
  }) || 0;
  useEffect(() => {
    getUsageTracker().track('legacySidegradeConfirmationButton', {
      action: 'viewed',
      productName: apiName,
      trackingSource
    });
  }, []);

  const handleClick = () => {
    getUsageTracker().track('legacySidegradeConfirmationButton', {
      action: 'clicked',
      productName: apiName,
      trackingSource
    });
    setModalVisible(true);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [modalVisible && /*#__PURE__*/_jsx(MarketingContactsSidegradeModal, {
      onClose: () => setModalVisible(false),
      history: history,
      skuId: skuId,
      ownedSkuId: ownedSkuId,
      queryParamTerm: queryParamTerm
    }), /*#__PURE__*/_jsx(UIAdminOnlyWrapper, {
      adminType: TEAM,
      modalType: REQUEST_SKU,
      upgradeData: upgradeData,
      children: /*#__PURE__*/_jsx(UIButton, {
        use: use,
        className: className,
        style: style,
        onClick: handleClick,
        "data-selenium-id": `${trackingSource}-${ownedSkuId}-confirm-contacts-button`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pricingCtas.buyAdditionalContacts"
        })
      })
    })]
  });
};

export default MarketingContactsSidegradeButton;